import * as Sentry from "@sentry/browser";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal`
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser } from "@remix-run/react";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { SENTRY_IGNORED_MESSAGE_PATTERNS, sentryBeforeSend } from "./lib/sentry-filters";

Sentry.init({
	dsn: "https://eb2fa60962aeb9f9acba121195aa2df0@o4509488131080192.ingest.us.sentry.io/4509491532791808",
	environment: import.meta.env.MODE,
	enabled: import.meta.env.PROD,
	beforeSend: sentryBeforeSend,
	ignoreErrors: SENTRY_IGNORED_MESSAGE_PATTERNS,
});

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<RemixBrowser />
		</StrictMode>,
	);
});
